import { env } from 'config';
import { OrderSciEvent, QueryParams } from 'types';
import { apiUtils } from 'utils';

const url = `${env.apiUrl}/order-sci-events`;

export const orderSciEventsApi = {
  getForOrder:
    (orderId: string) =>
    async (params?: Partial<QueryParams>): Promise<OrderSciEvent[]> =>
      (await apiUtils.getWithQueryParams(`${url}/${orderId}`, params)).data,
};
